import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-dashboard" }
const _hoisted_2 = { class: "mx-4" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "text-header-left" }
const _hoisted_5 = { class: "text-header-left fs-7 text-header" }
const _hoisted_6 = { class: "mt-5 px-0" }
const _hoisted_7 = { class: "mx-2 px-0 col-lg-12" }
const _hoisted_8 = { class: "mx-3 d-lg-flex justify-content-end" }
const _hoisted_9 = { class: "text-date mb-1 mt-lg-2 mx-lg-2 fw-bold fs-7" }
const _hoisted_10 = { class: "text-date" }
const _hoisted_11 = { class: "input-group flat-pickr" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1)
const _hoisted_13 = { class: "text-date mt-1 mb-1 mt-lg-2 mx-lg-2 fs-7 d-flex align-items-center" }
const _hoisted_14 = { class: "text-date" }
const _hoisted_15 = { class: "input-group flat-pickr tex-date" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1)
const _hoisted_17 = { class: "mx-4" }
const _hoisted_18 = { class: "fw-bold fs-7 text-date-analytic" }
const _hoisted_19 = { class: "mx-4" }
const _hoisted_20 = { class: "text-header-left fs-7" }
const _hoisted_21 = { class: "row mx-4" }

import { translate } from '@/languages/i18n'
import flatPickr from 'vue-flatpickr-component'
import { ref, computed } from 'vue'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import { setDate, ConvertYearMonthDay } from '@/constants/datepicker'
import { useStore } from 'vuex'

import LatestInformation from './components/LatestInformation.vue'
import ChartActiveUsers from './components/ChartActiveUsers.vue'
import ActionTable from './components/ActionTable.vue'
import InvitationRoutesTable from './components/InvitationRoutesTable.vue'
import GroupTable from './components/GroupTable.vue'
import PotsGraphChart from './components/PotsGraphChart.vue'
import { DASHBOARD_STORE } from '@/store/constants'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const latestAnalyticsDate = computed(() => store.getters[DASHBOARD_STORE.GETTERS.LATEST_ANALYTIC_DATE])
const openCalendar = ref()
const configDate = {
  disableMobile: true,
  locale: Japanese,
  wrap: true,
  dateFormat: 'Y/m/d',
  minDate: '2022/01/01',
  maxDate: setDate(1),
  onChange: function (selectedDates, dateStr, instance) {
    if (selectedDates.length === 0 && openCalendar.value === 'from') instance.setDate(setDate(28))
    if (selectedDates.length === 0 && openCalendar.value === 'to') instance.setDate(setDate(1))
  },
  onOpen: function (selectedDates, dateStr, instance) {
    if (instance.config.altInputClass.split(' ').includes('date-from')) {
      instance.config.maxDate = date.value.to
    }
    if (instance.config.altInputClass.split(' ').includes('date-to')) {
      instance.config.minDate = date.value.from
    }
  },
}
const handleClick = (key: string) => {
  openCalendar.value = key
}
const date = ref({
  from: setDate(28),
  to: setDate(1),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(translate)('CB10titleHeader')), 1)
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)('CB10titleHeader2')), 1)
    ]),
    _createVNode(LatestInformation),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)('CB10period')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(flatPickr), {
                modelValue: date.value.from,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date.value.from) = $event)),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick('from'))),
                config: configDate,
                class: "form-control bg-white fs-7 date-from"
              }, null, 8, ["modelValue"]),
              _hoisted_12
            ])
          ]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(translate)('SA20from')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(flatPickr), {
                modelValue: date.value.to,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((date.value.to) = $event)),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (handleClick('to'))),
                config: configDate,
                class: "form-control bg-white fs-7 date-to"
              }, null, 8, ["modelValue"]),
              _hoisted_16
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(translate)('CB10dateTitleHeader') + ' ') + " " + _toDisplayString(_unref(latestAnalyticsDate) ? _unref(ConvertYearMonthDay)(_unref(latestAnalyticsDate)) : '----/--/--'), 1)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(translate)('CB10titleHeader3')), 1)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(ChartActiveUsers, { date: date.value }, null, 8, ["date"]),
      _createVNode(InvitationRoutesTable, { date: date.value }, null, 8, ["date"]),
      _createVNode(ActionTable, { date: date.value }, null, 8, ["date"]),
      _createVNode(GroupTable, { date: date.value }, null, 8, ["date"]),
      _createVNode(PotsGraphChart, { date: date.value }, null, 8, ["date"])
    ])
  ]))
}
}

})